// extracted by css-extract-rspack-plugin
export default {"loadingContainer":"src-modules-desktop-modules-files-integration-components-FilePreviewModal-Preview-FilePreview-Html-HtmlPreview-module__loadingContainer-MrwQpM","container":"src-modules-desktop-modules-files-integration-components-FilePreviewModal-Preview-FilePreview-Html-HtmlPreview-module__container-xbG2Do","iframe":"src-modules-desktop-modules-files-integration-components-FilePreviewModal-Preview-FilePreview-Html-HtmlPreview-module__iframe-fZBfUI"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"loadingContainer\":\"src-modules-desktop-modules-files-integration-components-FilePreviewModal-Preview-FilePreview-Html-HtmlPreview-module__loadingContainer-MrwQpM\",\"container\":\"src-modules-desktop-modules-files-integration-components-FilePreviewModal-Preview-FilePreview-Html-HtmlPreview-module__container-xbG2Do\",\"iframe\":\"src-modules-desktop-modules-files-integration-components-FilePreviewModal-Preview-FilePreview-Html-HtmlPreview-module__iframe-fZBfUI\"}";
        // 1793874325676
        var cssReload = require("../../../../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  